import { Button, Flex, Icon, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

interface StepNavigationProps {
  onNext?: () => void;
  nextLabel?: string | null;
  onPrevious?: () => void;
  isNextDisabled?: boolean;
  isNextLoading?: boolean;
  nextTooltip?: string | null;
  nextIsAction?: boolean;
}

export const StepNavigation = ({
  onNext,
  nextLabel,
  onPrevious,
  isNextDisabled,
  isNextLoading,
  nextTooltip,
  nextIsAction,
}: StepNavigationProps) => {
  const { t } = useTranslation();

  const nextButtonText = nextIsAction
    ? (nextLabel ?? t("Next"))
    : nextLabel
      ? `${t("Next")}: ${nextLabel}`
      : t("Next");

  const nextButton = (
    <Button
      variant="solid"
      colorScheme="teal"
      size="lg"
      onClick={onNext}
      isDisabled={isNextDisabled}
      isLoading={isNextLoading}
      rightIcon={!nextIsAction ? <Icon as={FaChevronRight} w="12px" h="12px" /> : undefined}
      flex={{ md: "1" }}
      width={{ base: "full", md: "auto" }}
    >
      {nextButtonText}
    </Button>
  );

  return (
    <Flex direction={{ base: "column-reverse", md: "row" }} gap="3" width="full">
      {onPrevious && (
        <Button
          variant="outline"
          colorScheme="teal"
          size="lg"
          onClick={onPrevious}
          leftIcon={<Icon as={FaChevronLeft} w="12px" h="12px" />}
          flex={{ md: "1" }}
          width={{ base: "full", md: "auto" }}
        >
          {t("Previous")}
        </Button>
      )}
      {(onNext || (nextLabel && isNextDisabled)) && (
        nextTooltip ? (
          <Tooltip label={nextTooltip} hasArrow>
            {nextButton}
          </Tooltip>
        ) : (
          nextButton
        )
      )}
    </Flex>
  );
};
